/**
 * CFD 充值跳转路径，与 web-index 资产页 PC / 移动端规则一致：
 * - PC：统一 /wallet/account/common/deposit，query.mode = crypto | fiat
 * - 移动端：crypto → /deposit?currency=；fiat → /deposit/fiat?currency=
 * @see web-index/src/pages/wallet/account/spot/accountList/index.vue onOverviewDeposit / onSelectDeposit
 */

export interface CfdDepositLinkOptions {
  isFiat: boolean;
  /** 计价币种，如 USDT / AED；默认 USDT */
  quoteCurrency?: string;
  spikexPc?: boolean;
}

function normalizeQuoteCurrency(quoteCurrency?: string): string {
  return String(quoteCurrency || "USDT").toLowerCase();
}

/** 返回相对路径（不含域名），配合 Util.getUrl 使用 */
export function getCfdDepositPath({ isFiat, quoteCurrency, spikexPc = false }: CfdDepositLinkOptions): string {
  const currency = normalizeQuoteCurrency(quoteCurrency);

  if (spikexPc) {
    const params = new URLSearchParams({ mode: isFiat ? "fiat" : "crypto", currency });
    return `/wallet/account/common/deposit?${params.toString()}`;
  }

  if (isFiat) {
    return `/wallet/account/common/deposit/fiat?currency=${currency}`;
  }
  return `/wallet/account/common/deposit?currency=${currency}`;
}
